module.exports = __webpack_public_path__ + "img/bdcg.29a896e0.png";